export default "__VITE_ASSET__2005d095__"